"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultsManagerService = void 0;
var DefaultsManagerService = /** @class */ (function () {
    function DefaultsManagerService(consoleProps) {
        this.consoleProps = consoleProps;
        this.defaults = null;
        this.channel = consoleProps.data.channel;
        this.flowType = consoleProps.data.flowType;
        if (this.channel in DefaultsManagerService.CONSOLE_DEFAULTS) {
            this.defaults = DefaultsManagerService.CONSOLE_DEFAULTS[this.channel];
        }
        else {
            this.defaults = DefaultsManagerService.CONSOLE_DEFAULTS._default;
        }
    }
    DefaultsManagerService.prototype.getBoolean = function (key) {
        // console.log( `DefaultsManagerService checking ${key}` );
        if (this.consoleProps.options != null && key in this.consoleProps.options) {
            // console.log( `DefaultsManagerService found in options`,
            // ( ( this.consoleProps.options as ChannelDefaults )[ key ] ) );
            return this.consoleProps.options[key];
        }
        else if (key in this.defaults) {
            // console.log( `DefaultsManagerService looking in defaults`, this.defaults[ key ] );
            return this.defaults[key];
        }
        // console.log( 'DefaultsManagerService is on default false' );
        return false;
    };
    DefaultsManagerService.prototype.getString = function (key) {
        if (this.consoleProps.options != null && key in this.consoleProps.options) {
            // console.log( `DefaultsManagerService found in options`,
            // ( ( this.consoleProps.options as ChannelDefaults )[ key ] ) );
            return this.consoleProps.options[key];
        }
        else if (key in this.defaults) {
            // console.log( `DefaultsManagerService looking in defaults`, this.defaults[ key ] );
            return this.defaults[key];
        }
        return null;
    };
    DefaultsManagerService.CONSOLE_DEFAULTS = {
        sales: {
            suppressHeader: false,
            suppressSkipAuthLink: false,
            suppressSavedId: false,
            suppressCreateOneLink: false,
            showUnauthenticatedPayments: false,
            suppressUserIdPopupLinks: false,
            registrationOriginationPoint: 'idplgn',
        },
        services: {
            suppressHeader: false,
            suppressSkipAuthLink: true,
            suppressSavedId: false,
            suppressCreateOneLink: false,
            showUnauthenticatedPayments: false,
            suppressUserIdPopupLinks: false,
            registrationOriginationPoint: 'idplgn',
        },
        acctmgmt: {
            suppressHeader: false,
            suppressSkipAuthLink: true,
            suppressSavedId: false,
            suppressCreateOneLink: false,
            showUnauthenticatedPayments: false,
            suppressUserIdPopupLinks: false,
            registrationOriginationPoint: 'idplgn',
        },
        support: {
            suppressHeader: false,
            suppressSkipAuthLink: false,
            suppressSavedId: false,
            suppressCreateOneLink: false,
            showUnauthenticatedPayments: false,
            suppressUserIdPopupLinks: false,
            registrationOriginationPoint: 'idplgn',
        },
        _default: {
            suppressHeader: false,
            suppressSkipAuthLink: true,
            suppressSavedId: false,
            suppressCreateOneLink: false,
            showUnauthenticatedPayments: false,
            suppressUserIdPopupLinks: false,
            registrationOriginationPoint: 'idplgn',
        },
    };
    return DefaultsManagerService;
}());
exports.DefaultsManagerService = DefaultsManagerService;
//# sourceMappingURL=DefaultsManagerService.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/services/DefaultsManagerService.js
// module id = 1686
// module chunks = 8